const FRIENDLY_ERROR_RULES = [
  {
    test: /valid end time is required|end time is required|endtime is required/i,
    message: 'Please enter a valid end date and time, or leave it empty.',
  },
  {
    test: /start time must be in the future/i,
    message: 'Start time must be in the future.',
  },
  {
    test: /invalid meeting date or time/i,
    message: 'Please check the meeting date and time values.',
  },
  {
    test: /validation failed/i,
    message: 'Some fields are invalid. Please review and try again.',
  },
];

const toFriendlyMessage = (rawMessage) => {
  if (!rawMessage || typeof rawMessage !== 'string') {
    return '';
  }

  const normalized = rawMessage.trim();
  if (!normalized) {
    return '';
  }

  const match = FRIENDLY_ERROR_RULES.find((rule) => rule.test.test(normalized));
  return match ? match.message : normalized;
};

export const normalizeApiError = (error, fallback = 'Something went wrong. Please try again.') => {
  const validationErrors = error?.response?.data?.errors;
  if (Array.isArray(validationErrors) && validationErrors.length > 0) {
    return validationErrors
      .map((item) => toFriendlyMessage(item?.message))
      .filter(Boolean)
      .join(' • ');
  }

  const directMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.message;

  const friendlyDirectMessage = toFriendlyMessage(directMessage);
  return friendlyDirectMessage || fallback;
};
